export enum SharedWith {
  NotShared = '',
  OnlyMe = 'Only Me',
  Company = 'Company',
  Department = 'Department',
}
